/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItemsLanding_similarItems$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_similarLandingItems$ref: FragmentReference;
export type PdpRespContainer_similarLandingItems = {|
  +$fragmentRefs: PdpRespSimilarItemsLanding_similarItems$ref,
  +$refType: PdpRespContainer_similarLandingItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_similarLandingItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '41b67f509beac092dead980409e13c01';
module.exports = node;
